import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { eur } from 'types';
import StripePayment from '../components/shared/payment/StripePayment';
import { toRequest, useBooking } from '../state/BookingContext';

export default function CheckoutPage() {
  const navigate = useNavigate();
  const { draft } = useBooking();
  const inv = draft.invoice;
  // Only pay the invoice that was created for exactly the booking on screen.
  const ready = !!inv && !inv.free && !!inv.clientSecret && inv.fingerprint === JSON.stringify(toRequest(draft));

  useEffect(() => {
    if (!ready) navigate('/review', { replace: true });
  }, [ready, navigate]);

  if (!ready || !inv) return null;
  return (
    <div className="max-w-xl mx-auto space-y-4">
      <h2 className="text-xl font-semibold text-gray-800">Payment</h2>
      <p className="text-sm text-gray-700">
        Total to pay: <span className="font-bold">{eur(inv.quote.totalCents)}</span> for {draft.customer.name.trim()}. Choose a payment method below.
      </p>
      <StripePayment clientSecret={inv.clientSecret!} paymentIntentId={inv.paymentIntentId!} amountCents={inv.quote.totalCents} customer={{ name: draft.customer.name.trim(), email: draft.customer.email.trim() }} />
      <Link to="/review" className="block text-center text-sm text-orange-700 underline">← Back to review</Link>
    </div>
  );
}
